const COOKIE_CONSENT_KEY = 'cookieConsent';
const CONSENT_EXPIRY_DAYS = 365;

export type ConsentPreferences = {
  necessary: boolean;
  analytics: boolean;
  timestamp: number;
};

export const getCookieConsent = (): ConsentPreferences | null => {
  if (typeof window === 'undefined') return null;

  try {
    const stored = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!stored) return null;

    const preferences = JSON.parse(stored) as ConsentPreferences;

    const expiryTime = preferences.timestamp + (CONSENT_EXPIRY_DAYS * 24 * 60 * 60 * 1000);
    if (Date.now() > expiryTime) {
      localStorage.removeItem(COOKIE_CONSENT_KEY);
      return null;
    }

    return preferences;
  } catch (error) {
    console.error('Error reading cookie consent:', error);
    return null;
  }
};

export const setCookieConsent = (preferences: Omit<ConsentPreferences, 'timestamp'>): void => {
  if (typeof window === 'undefined') return;

  try {
    const consentData: ConsentPreferences = {
      ...preferences,
      timestamp: Date.now()
    };

    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify(consentData));

    if (preferences.analytics) {
      initializeAnalytics();
    }
  } catch (error) {
    console.error('Error saving cookie consent:', error);
  }
};

export const hasConsentForAnalytics = (): boolean => {
  const consent = getCookieConsent();
  return consent?.analytics === true;
};

export const initializeAnalytics = (): void => {
  if (typeof window === 'undefined') return;

  if (window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: 'granted'
    });
  }
};

export const revokeAnalytics = (): void => {
  if (typeof window === 'undefined') return;

  if (window.gtag) {
    window.gtag('consent', 'update', {
      analytics_storage: 'denied'
    });
  }
};
